import api from './api';

const v2VaultOhipTestService = {
  testConnection: async (v2_vault_id) => {
    const response = await api.post('/v2-vault-ohip-test', { v2_vault_id });
    return response.data;
  },

  estimateRecords: async (v2_vault_id) => {
    const response = await api.post('/v2-vault-ohip-estimate', { v2_vault_id });
    return response.data;
  },

  sendExtractCode: async (v2_vault_id) => {
    const response = await api.post('/v2-vault-ohip-extract-code', { v2_vault_id });
    return response.data;
  },

  confirmExtractCode: async (v2_vault_id, code) => {
    const response = await api.post('/v2-vault-ohip-extract-confirm', { v2_vault_id, code });
    return response.data;
  },
};

export default v2VaultOhipTestService;
